import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import * as moment from 'moment';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';
import { fetchApi } from '../../services/api';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    index: number;
    lead: LeadData|undefined;
    Validation: boolean;
    Selected: number;
    academicUser: boolean;
}

export type LeadData = {
    Facilities: Array<{ FacilityId: number, Name: string }>;
    FacilityID: number;
    ChildId: number;
    FirstName: string;
    LastName: string;
    Gender: number | null;
    BirthDate: Date | null;
    Phone: string ;
    HomeAddress: StreetAddressViewModel;
    LastDay: Date | null;
    Breakfast: string;
    Lunch: string;
    Snack: string;
    HasBreakfast: boolean;
    HasLunch: boolean;
    HasSnack: boolean;
    NapOne1: Date | null;
    NapOne2: Date | null;
    NapTwo1: Date | null;
    NapTwo2: Date | null;
    NapThree1: Date | null;
    NapThree2: Date | null;
    BottleOne: Date | null;
    BottleTwo: Date | null;
    BottleThree: Date | null;
    TenantName: string;
    EmergencyFirstName: string;
    EmergencyLastName: string;
    EmergencyPhone: string;
    EmergencyRelation: string;
    EmergencyAddress: StreetAddressViewModel | null;
    IsLoading: boolean;
}

export default class Profile extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            lead: undefined,
            index: 0,
            Validation: false,
            Selected: 0,
            academicUser: false,
        }

        this.save = this.save.bind(this);
        this.copy = this.copy.bind(this);
        this.print = this.print.bind(this);
        this.setGender = this.setGender.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestLead(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.lead && this.state.lead.ChildId != childId) {
            this.requestLead(childId);
        }
    }

    public render() {
        return <div>
            {this.state.lead &&
                <form className="k-form">
                    <DocumentTitle title={`${this.state.lead.FirstName} ${this.state.lead.LastName}`} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <br />
                    <h5>Location</h5>
                    {this.state.lead.Facilities.length > 0 &&
                        <DropDownList
                            textField='Name'
                            data={this.state.lead.Facilities}
                            value={this.state.lead.Facilities.find(x => x.FacilityId === (this.state.lead as LeadData).FacilityID)}
                            onChange={(e) => {
                                this.updateLeadState({ FacilityID: e.target.value.FacilityId });
                            }}
                            style={{ width: '100%' }}
                        />
                    }
                    <br/>
                    <h5>Child information</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">First and Last Name<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <input
                                    className="form-control"
                                    type="text"
                                    name={`FirstName`}
                                    placeholder="First Name"
                                    value={this.state.lead.FirstName}
                                    onChange={(e) => this.updateLeadState({ FirstName: e.target.value })}
                                />
                                <input
                                    className="form-control"
                                    type="text"
                                    name={`LastName`}
                                    placeholder="Last Name"
                                    value={this.state.lead.LastName}
                                    onChange={(e) => this.updateLeadState({ LastName: e.target.value })}
                                />
                            </div>
                            {this.state.Validation && !this.state.lead.FirstName && !this.state.lead.LastName && <p className="error-msg">First and Last Name are Required</p>}
                            {this.state.Validation && !this.state.lead.FirstName && this.state.lead.LastName && <p className="error-msg">First Name is Required</p>}
                            {this.state.Validation && this.state.lead.FirstName && !this.state.lead.LastName && <p className="error-msg">Last Name is Required</p>}
                            {this.state.Validation && this.state.lead.FirstName && this.state.lead.LastName && <br/> || !this.state.Validation && <br/>}
                            <div className="k-form-field" onChange={this.setGender}>
                                <span>Gender<span style={{ color: '#dc3545' }}>*</span></span>
                                <input
                                    type="radio"
                                    name="Child.Gender"
                                    id="Child.Female"
                                    value="1"
                                    className="k-radio"
                                    checked={this.state.lead.Gender === 1}
                                />
                                <label className="k-radio-label" htmlFor="Child.Female">Female</label>
                                <input
                                    type="radio"
                                    name="Child.Gender"
                                    id="Child.Male"
                                    value="0"
                                    className="k-radio"
                                    checked={this.state.lead.Gender === 0}
                                />
                                <label className="k-radio-label" htmlFor="Child.Male">Male</label>
                                {this.state.Validation && this.state.lead.Gender !== 0 && this.state.lead.Gender !== 1 && <div><p className="error-msg">Gender is Required</p></div>}
                            </div>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Date of Birth<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    max={moment().toDate()}
                                    name={`BirthDate`}
                                    formatPlaceholder="formatPattern"
                                    value={this.state.lead.BirthDate}
                                    onChange={(e) => this.updateLeadState({ BirthDate: e.value })}
                                />
                            </div>
                            {(this.state.Validation && !this.state.lead.BirthDate) ? <p className="error-msg">Birth Date is Required</p> : <br/>}
                            <label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Home Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                                    </div>
                                    <MaskedTextBox
                                        mask="(000)000-0000"
                                        name={`Phone`}
                                        placeholder="(000)000-0000"
                                        value={this.state.lead.Phone || ''}
                                        onChange={(e) => this.updateLeadState({ Phone: e.target.value.replace(/_/g, "") })}
                                    />
                                </div>
                            </label>
                            {(this.state.Validation && (!this.state.lead.Phone || this.state.lead.Phone.length < 13)) ? <p className="error-msg">Home Phone Number is Required</p> : <br/>}
                            <StreetAddress
                                address={this.state.lead.HomeAddress}
                                onChange={(newAddress) => this.updateLeadState({ HomeAddress: newAddress })}
                                title="Home Address"
                                required
                                validation={this.state.Validation}
                            />
                            <br/><br />
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Last Day</span>
                                </div>
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    name={`LastDay`}
                                    formatPlaceholder="formatPattern"
                                    value={this.state.lead.LastDay ? moment.utc(this.state.lead.LastDay).toDate() : null}
                                    onChange={(e) => this.updateLeadState({ LastDay: e.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <br/>
                    {!this.state.academicUser && <React.Fragment>
                        <h5>Infant Daily Schedule</h5>
                        <div className="card">
                            <div className="card-body">
                                <h6>When does your child eat?</h6>
                                <br/>
                                <label className="k-form-field">
                                    <input type="checkbox" id="Breakfast" className="k-checkbox" checked={this.state.lead.HasBreakfast} onChange={(e) => this.updateLeadState({HasBreakfast: e.target.checked})}/>
                                    <label className="k-checkbox-label" htmlFor="Breakfast">Breakfast</label>
                                </label>
                                {this.state.lead.HasBreakfast &&
                                <textarea
                                    name="breakfast"
                                    className="form-control"
                                    placeholder="Describe meal"
                                    value={this.state.lead.Breakfast}
                                    onChange={(e) => this.updateLeadState({ Breakfast: e.target.value })}
                                />}
                            {this.state.lead.HasBreakfast && <br/>}
                                <label className="k-form-field">
                                    <input type="checkbox" id="Lunch" className="k-checkbox" checked={this.state.lead.HasLunch} onChange={(e) => this.updateLeadState({HasLunch: e.target.checked})}/>
                                    <label className="k-checkbox-label" htmlFor="Lunch">Lunch</label>
                                </label>
                                {this.state.lead.HasLunch &&
                                <textarea
                                    name="lunch"
                                    className="form-control"
                                    placeholder="Describe meal"
                                    value={this.state.lead.Lunch}
                                    onChange={(e) => this.updateLeadState({ Lunch: e.target.value })}
                                />}
                            {this.state.lead.HasLunch && <br/>}
                                <label className="k-form-field">
                                    <input type="checkbox" id="Snack" className="k-checkbox" checked={this.state.lead.HasSnack} onChange={(e) => this.updateLeadState({HasSnack: e.target.checked})}/>
                                    <label className="k-checkbox-label" htmlFor="Snack">Afternoon Snack</label>
                                </label>
                                {this.state.lead.HasSnack &&
                                <textarea
                                    name="snack"
                                    className="form-control"
                                    placeholder="Describe meal"
                                    value={this.state.lead.Snack}
                                    onChange={(e) => this.updateLeadState({ Snack: e.target.value })}
                                />}
                                {this.state.lead.HasSnack && <br/>}
                                <br/>
                                <h6>When does your child nap?</h6>
                                <br/>
                                <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapOne1}
                                    onChange={(e) => this.updateLeadState({ NapOne1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text inputGroupPrepend">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapOne2}
                                    onChange={(e) => this.updateLeadState({ NapOne2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapTwo1}
                                    onChange={(e) => this.updateLeadState({ NapTwo1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapTwo2}
                                    onChange={(e) => this.updateLeadState({ NapTwo2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">From</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapThree1}
                                    onChange={(e) => this.updateLeadState({ NapThree1: e.target.value})}
                                />
                                <div className="input-group-prepend">
                                    <span className="input-group-text">To</span>
                                </div>
                                <TimePicker
                                    name="Nap"
                                    format="hh:mm a"
                                    formatPlaceholder="formatPattern"
                                    className="form-control"
                                    value={this.state.lead.NapThree2}
                                    onChange={(e) => this.updateLeadState({ NapThree2: e.target.value})}
                                />
                            </div>
                            <br/>
                            <h6>When does your child have their bottles?</h6>
                            <br/>
                            <label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Bottle times</span>
                                    </div>
                                    <TimePicker
                                        name="BottleOne"
                                        className="form-control"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        value={this.state.lead.BottleOne}
                                        onChange={(e) => this.updateLeadState({ BottleOne: e.target.value})}
                                    />
                                    <TimePicker
                                        name="BottleTwo"
                                        className="form-control"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        value={this.state.lead.BottleTwo}
                                        onChange={(e) => this.updateLeadState({ BottleTwo: e.target.value})}
                                    />
                                    <TimePicker
                                        name="BottleThree"
                                        format="hh:mm a"
                                        formatPlaceholder="formatPattern"
                                        className="form-control"
                                        value={this.state.lead.BottleThree}
                                        onChange={(e) => this.updateLeadState({ BottleThree: e.target.value})}
                                    />
                                </div>
                            </label>
                            </div>
                        </div>
                        <br/>
                        <br/>
                    </React.Fragment>}
                    <h5>Emergency Contact</h5>
                    <div className="card">
                        <div className="card-body">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Relation to Child<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <label id="name"></label>
                                <input
                                    type="string"
                                    name="name"
                                    placeholder="Grandparent, Family Friend, etc..."
                                    className="form-control"
                                    value={this.state.lead.EmergencyRelation}
                                    onChange={(e) => this.updateLeadState({ EmergencyRelation: e.target.value })}
                                />
                            </div>
                            {(this.state.Validation && !this.state.lead.EmergencyRelation) ? <p className="error-msg">Relation to Child is Required</p> : <br/>}
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">First and Last Name<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="First Name"
                                    className="form-control"
                                    value={this.state.lead.EmergencyFirstName}
                                    onChange={(e) => this.updateLeadState({ EmergencyFirstName: e.target.value })}
                                />
                                <input
                                    type="text"
                                    placeholder="Last Name"
                                    className="form-control"
                                    value={this.state.lead.EmergencyLastName}
                                    onChange={(e) => this.updateLeadState({ EmergencyLastName: e.target.value })}
                                />
                            </div>
                            {this.state.Validation && !this.state.lead.EmergencyFirstName && !this.state.lead.EmergencyLastName && <p className="error-msg">First and Last Name are Required</p>}
                            {this.state.Validation && !this.state.lead.EmergencyFirstName && this.state.lead.EmergencyLastName && <p className="error-msg">First Name is Required</p>}
                            {this.state.Validation && this.state.lead.EmergencyFirstName && !this.state.lead.EmergencyLastName && <p className="error-msg">Last Name is Required</p>}
                            {this.state.Validation && this.state.lead.EmergencyFirstName && this.state.lead.EmergencyLastName && <br/> || !this.state.Validation && <br/>}
                            <label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                                    </div>
                                    <MaskedTextBox
                                        mask="(000)000-0000"
                                        name="Phone"
                                        placeholder="(000)000-0000"
                                        value={this.state.lead.EmergencyPhone || ''}
                                        onChange={(e) => this.updateLeadState({ EmergencyPhone: e.target.value.replace(/_/g, "") })}
                                    />
                                </div>
                            </label>
                            {(this.state.Validation && (!this.state.lead.EmergencyPhone || this.state.lead.EmergencyPhone.length < 13 )) ? <p className="error-msg">Phone Number is Required</p> : <br/>}
                            <StreetAddress
                                address={this.state.lead.EmergencyAddress}
                                onChange={(newAddress) => this.updateLeadState({ EmergencyAddress: newAddress })}
                                title="Emergency Address"
                                validation={this.state.Validation}
                            />
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <LoadingButton 
                        onClick={this.save}
                        disabled={!this.state.isDirty}
                        isLoading={this.state.isLoading}
                        isLoadingText="Saving..."
                        className="btn btn-primary"
                    >
                        Save
                    </LoadingButton>
                    &nbsp;<Button onClick={this.copy}>Copy</Button>
                    {!this.state.lead.IsLoading && <button type="button" className="btn btn-primary float-right" onClick={this.print}>Print</button>}
                    {this.state.lead.IsLoading && <div className="k-loading-image"></div>}
                    <br/>
                    <br/>
                </form>
            }
        </div>;
    }

    private setGender(e: any) {
        this.updateLeadState({ Gender: parseInt(e.target.value) });
    }

    private updateLeadState(value: Object|LeadData) {
        const lead = Object.assign({}, this.state.lead, value);
        this.setState({ lead, isDirty: true });
    }

    private save(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        this.setState({ Validation: true }, () => {
            if (this.state.lead && document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                fetchApi(`api/Children/Save/${this.state.lead.ChildId}`, this.state.lead, 'POST')
                    .then((response: { Message: string, Errors: Array<{ Field: string, Message: string }> }) => {
                        this.setState({ isLoading: false });
                        if (!response.Errors)
                        {
                            this.setState({ isLoading: false, isDirty: false });
                        }
                    }).catch(() => {
                        this.setState({ isLoading: false });
                        // TODO: Show error
                    })
            } else {
                document.getElementsByClassName("error-msg")[0].scrollIntoView({ block: "center" });
            }
        });
    }

    private copy(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        if (this.state.lead) {
            this.props.history.push(`/child/${this.state.lead.ChildId}/copy`);
        }
    }

    private print(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        if (this.state.lead) {
            this.props.history.push(`/child/${this.state.lead.ChildId}/print`);
        }
    }

    private requestLead(leadId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/Children/Get/${leadId}`)
            .then((response: { Child: LeadData, AcademicUser: boolean }) => {
                response.Child.BirthDate = response.Child.BirthDate ? moment.utc(response.Child.BirthDate).toDate() : null;
                response.Child.NapOne1 = response.Child.NapOne1 ? moment.utc(response.Child.NapOne1).toDate() : null;
                response.Child.NapOne2 = response.Child.NapOne2 ? moment.utc(response.Child.NapOne2).toDate() : null;
                response.Child.NapTwo1 = response.Child.NapTwo1 ? moment.utc(response.Child.NapTwo1).toDate() : null;
                response.Child.NapTwo2 = response.Child.NapTwo2 ? moment.utc(response.Child.NapTwo2).toDate() : null;
                response.Child.NapThree1 = response.Child.NapThree1 ? moment.utc(response.Child.NapThree1).toDate() : null;
                response.Child.NapThree2 = response.Child.NapThree2 ? moment.utc(response.Child.NapThree2).toDate() : null;
                response.Child.BottleOne = response.Child.BottleOne ? moment.utc(response.Child.BottleOne).toDate() : null;
                response.Child.BottleTwo = response.Child.BottleTwo ? moment.utc(response.Child.BottleTwo).toDate() : null;
                response.Child.BottleThree = response.Child.BottleThree ? moment.utc(response.Child.BottleThree).toDate() : null;
                this.setState({ isLoading: false, isDirty: false, lead: response.Child, academicUser: response.AcademicUser });
            });
    }
}
